import PromisedResource from './PromisedResource'
import { InitializedRecord } from '@orbit/records'

export default class ClientCampaignGroupsResource extends PromisedResource<InitializedRecord[]> {
  constructor({ remote, contract }) {
    super(remote.query(q => q.findRelatedRecords(contract, 'clientCampaignGroups')))
  }
}
